/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.NoBoxCRM {

    @Serenity.Decorators.registerClass()
    export class FormFollowUpDialog extends NoboxEntityDialog<FormresultsRow, any> {
        protected getFormKey() { return FormFollowUp.formKey; }
        protected getIdProperty() { return FormresultsRow.idProperty; }
        protected getLocalTextPrefix() { return FormresultsRow.localTextPrefix; }
        protected getNameProperty() { return FormresultsRow.nameProperty; }
        protected getService() { return FormresultsService.baseUrl; }
        protected getDeletePermission() { return FormresultsRow.deletePermission; }
        protected getInsertPermission() { return FormresultsRow.insertPermission; }
        protected getUpdatePermission() { return FormresultsRow.updatePermission; }

        protected form = new FormFollowUp(this.idPrefix);
        protected paymentMethod: number = 0;
        formResultEntity: FormresultsRow = null;
        protected dataFollowUp: Array<followUp> = [
            {
                "id": 1,
                "title": "Welcome",
                "data": [
                    {
                        "id": 1,
                        "title": "Basic",
                        "text": ""
                    },
                    {
                        "id": 2,
                        "title": "Bank Transfer",
                        "text": ""
                    },
                    {
                        "id": 3,
                        "title": "COD",
                        "text": ""
                    },
                    {
                        "id": 4,
                        "title": "E-Payment",
                        "text": ""
                    }
                ]
            },
            {
                "id": 2,
                "title": "Order Detail",
                "data": [
                    {
                        "id": 1,
                        "title": "Basic",
                        "text": ""
                    },
                    {
                        "id": 2,
                        "title": "Bank Transfer",
                        "text": ""
                    },
                    {
                        "id": 3,
                        "title": "COD",
                        "text": ""
                    },
                    {
                        "id": 4,
                        "title": "E-Payment",
                        "text": ""
                    }
                ]
            },
            {
                "id": 3,
                "title": "Follow Up 1",
                "data": [
                    {
                        "id": 1,
                        "title": "Basic",
                        "text": ""
                    },
                    {
                        "id": 2,
                        "title": "Bank Transfer",
                        "text": ""
                    },
                    {
                        "id": 3,
                        "title": "COD",
                        "text": ""
                    },
                    {
                        "id": 4,
                        "title": "E-Payment",
                        "text": ""
                    }
                ]
            },
            {
                "id": 4,
                "title": "Follow Up 2",
                "data": [
                    {
                        "id": 1,
                        "title": "Basic",
                        "text": "Siap"
                    },
                    {
                        "id": 2,
                        "title": "Bank Transfer",
                        "text": "Ok"
                    },
                    {
                        "id": 3,
                        "title": "COD",
                        "text": ""
                    },
                    {
                        "id": 4,
                        "title": "E-Payment",
                        "text": ""
                    }
                ]
            },
            {
                "id": 5,
                "title": "Follow Up 3",
                "data": [
                    {
                        "id": 1,
                        "title": "Basic",
                        "text": "Siap 1"
                    },
                    {
                        "id": 2,
                        "title": "Bank Transfer",
                        "text": "ok 1"
                    },
                    {
                        "id": 3,
                        "title": "COD",
                        "text": ""
                    },
                    {
                        "id": 4,
                        "title": "E-Payment",
                        "text": ""
                    }
                ]
            },
            {
                "id": 6,
                "title": "Processing",
                "data": [
                    {
                        "id": 1,
                        "title": "Basic",
                        "text": ""
                    },
                    {
                        "id": 2,
                        "title": "Bank Transfer",
                        "text": ""
                    },
                    {
                        "id": 3,
                        "title": "COD",
                        "text": ""
                    },
                    {
                        "id": 4,
                        "title": "E-Payment",
                        "text": ""
                    }
                ]
            },
            {
                "id": 7,
                "title": "Complete",
                "data": [
                    {
                        "id": 1,
                        "title": "Basic",
                        "text": ""
                    },
                    {
                        "id": 2,
                        "title": "Bank Transfer",
                        "text": ""
                    },
                    {
                        "id": 3,
                        "title": "COD",
                        "text": ""
                    },
                    {
                        "id": 4,
                        "title": "E-Payment",
                        "text": ""
                    }
                ]
            },
            {
                "id": 8,
                "title": "Up Selling",
                "data": [
                    {
                        "id": 1,
                        "title": "Basic",
                        "text": ""
                    },
                    {
                        "id": 2,
                        "title": "Bank Transfer",
                        "text": ""
                    },
                    {
                        "id": 3,
                        "title": "COD",
                        "text": ""
                    },
                    {
                        "id": 4,
                        "title": "E-Payment",
                        "text": ""
                    }
                ]
            },
            {
                "id": 9,
                "title": "Redirect",
                "data": [
                    {
                        "id": 1,
                        "title": "Basic",
                        "text": "Thank's for filled form"
                    },
                    {
                        "id": 2,
                        "title": "Bank Transfer",
                        "text": "Order via Bank Transfer"
                    },
                    {
                        "id": 3,
                        "title": "COD",
                        "text": "Order via COD"
                    },
                    {
                        "id": 4,
                        "title": "E-Payment",
                        "text": "Order via E-Payment"
                    }
                ]
            }
        ];

        protected jsonSetting: any = JSON.parse($("#ScriptDefault").text());
        protected countryCode = this.jsonSetting.CountryCode;
        protected formatNum = this.jsonSetting.NumberFormat;
        protected formatDate = this.jsonSetting.DateFormat;
        protected currency = this.jsonSetting.Currencies;
        protected emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        constructor() {
            super();
            this.form.FrmFollowUp.change(() => {
                var data = this.getFollowUpData(this.form.FrmFollowUp.value);
                this.form.FollowUp.value = this.form.FrmFollowUp.value;
                if (data != null) {
                    this.form.Text.value = this.replaceVariables(data.text, this.mappingEnitity(this.formResultEntity));
                } else {
                    this.form.Text.value = "";
                }
            });
        }
        autoNumericFormatter(val) {
            var input = $(`<input type="text">`);

            var optionAuto = $.cookie("formatnumber");
            if (optionAuto == null) {
                input.autoNumeric('init');
            } else {
                var formatnumber = JSON.parse(decodeURIComponent(optionAuto));
                if (jQuery.isEmptyObject(formatnumber)) {
                } else {
                    var obj = {};
                    if ('aDec' in formatnumber) {
                        obj["aDec"] = formatnumber["aDec"];
                    }
                    if ('mDec' in formatnumber) {
                        obj["mDec"] = formatnumber["mDec"];
                    }
                    if ('aSep' in formatnumber) {
                        obj["aSep"] = formatnumber["aSep"];
                    }
                    if ('dGroup' in formatnumber) {
                        obj["dGroup"] = formatnumber["dGroup"];
                    }
                    if ('lZero' in formatnumber) {
                        obj["lZero"] = formatnumber["lZero"];
                    }
                    input.autoNumeric('init', obj);
                }
            }
            if (val == "" || val == null) {
                return "";
            } else {
                input.autoNumeric('set', val);
                return input.val();
            }
        }
        replaceVariables(inputString, variableValues) {
            return inputString.replace(/{(.*?)}/g, function (match, p1) {
                return variableValues[p1.trim()] || "";
            });
        }

        mappingEnitity(item: FormresultsRow) {
            var entity = {
                form_template: "",
                order_id: 0,
                order_date: "",
                products: "",
                grand_total: "",
                coupon_code: "",
                payment_method: "",
                bank_accounts: "",
                additional_cost_label: "",
                additional_cost: "",
                reduction_cost_label: "",
                reduction_cost: "",
                customer_name: "",
                customer_phone: "",
                customer_email: "",
                customer_note: "",
                customer_country: "",
                customer_address: "",
                customer_city: "",
                customer_state: ""
            };
            if (item != null) {
                entity.form_template = item.Form;
                var Data = JSON.parse(item.Data);
                entity.order_id = item.Id;
                entity.order_date = moment(item.DateIn).format(this.formatDate);
                if (Data.dataCoupon) {
                    entity.coupon_code = Data.dataCoupon;
                }
                if (Data.dataPay) {
                    var dataPay = Data.dataPay;
                    if (dataPay.type) {
                        var type = dataPay.type - 1;
                        if (type == 1) {
                            entity.payment_method = "Bank Transfer";
                            if (dataPay.list) {
                                var dataPayList = dataPay.list.findIndex(dp => dp.Id == dataPay.selected);
                                if (dataPayList != -1) {
                                    entity.bank_accounts = dataPay.list[dataPayList].Name;
                                }
                            }
                        } else if (type == 2) {
                            entity.payment_method = "COD";
                        } else if (type == 3) {
                            entity.payment_method = "E-Payment";
                        }
                    }
                }
                entity.additional_cost = "";
                entity.reduction_cost = "";
                entity.customer_name = item.SenderNm;
                entity.customer_phone = item.Phone;
                if (Data.dataField) {
                    var adrresField = Data.dataField.findIndex(x => x.id == 5);
                    if (adrresField != -1) {
                        if (Data.dataField[adrresField].value) {
                            entity.customer_address = Data.dataField[adrresField].value;
                        }
                    }
                    var emailField = Data.dataField.findIndex(x => x.id == 3);
                    if (emailField != -1) {
                        if (Data.dataField[emailField].value) {
                            entity.customer_email = Data.dataField[emailField].value;
                        }
                    }
                    var noteField = Data.dataField.findIndex(x => x.id == 4);
                    if (noteField != -1) {
                        if (Data.dataField[noteField].value) {
                            entity.customer_note = Data.dataField[noteField].value;
                        }
                    }
                    var countryField = Data.dataField.findIndex(x => x.id == 6);
                    if (countryField != -1) {
                        if (Data.dataField[countryField].value) {
                            var it = JSON.parse(Data.dataField[countryField].value);
                            entity.customer_country = it.text;
                        }
                    }
                    var cityField = Data.dataField.findIndex(x => x.id == 8);
                    if (cityField != -1) {
                        if (Data.dataField[cityField].value) {
                            var it = JSON.parse(Data.dataField[cityField].value);
                            entity.customer_city = it.text;
                        }
                    }
                    var stateField = Data.dataField.findIndex(x => x.id == 7);
                    if (stateField != -1) {
                        if (Data.dataField[stateField].value) {
                            var it = JSON.parse(Data.dataField[stateField].value);
                            entity.customer_state = it.text;
                        }
                    }
                }

                if (Data.dataCustom) {
                    var DataCustom = Data.dataCustom;
                    entity.additional_cost_label = DataCustom.additional || "";
                    entity.additional_cost = this.currency + " " + this.autoNumericFormatter(DataCustom.additionalPrice) || "";
                    entity.reduction_cost_label = DataCustom.reduction || "";
                    entity.reduction_cost = this.currency + " " + this.autoNumericFormatter(DataCustom.reductionPrice) || "";
                }

                if (item.Products) {
                    let grandTotal = 0;
                    let strPdts = ``;
                    item.Products.forEach((obj, ind) => {
                        if (ind == 0) {
                            strPdts += "Products: \n"
                        }
                        strPdts += `- ${obj.ProductName} @${obj.Currencies} ${this.autoNumericFormatter(obj.TotalPrice)} x ${obj.Quantity} = ${obj.Currencies} ${this.autoNumericFormatter(obj.FinalTotalPrice)}\n`;
                        grandTotal += obj.FinalTotalPrice;
                    });
                    strPdts += `\nTotal Price: ${this.currency} ${this.autoNumericFormatter(grandTotal)}`
                    if (Data.dataCustom) {
                        grandTotal = grandTotal + Number(Data.dataCustom.additionalPrice ?? 0) - Number(Data.dataCustom.reductionPrice ?? 0);
                        if (Data.dataCustom.additional) {
                            strPdts += `\n${Data.dataCustom.additional}: ${this.currency} ${this.autoNumericFormatter(Data.dataCustom.additionalPrice)}`;
                        }
                        if (Data.dataCustom.reduction) {
                            strPdts += `\n${Data.dataCustom.reduction}: (${this.currency} ${this.autoNumericFormatter(Data.dataCustom.reductionPrice)})`;
                        }
                        strPdts += `\nGrand Total: ${this.currency} ${this.autoNumericFormatter(grandTotal)}`
                    }

                    entity.products = strPdts;
                    entity.grand_total = `${this.currency} ${this.autoNumericFormatter(grandTotal)}`
                }

                return entity;
            } else {
                return entity;
            }
        }

        updateTitle() {
            if (this.isNew()) {

                this.dialogTitle = "Follow Up";
            } else {
                var item = this.get_entity();
                this.dialogTitle = `Follow Up #${item.Id}`;
            }
        }

        updateInterface() {
            super.updateInterface();
            var entity = this.entity;
            if (this.isEditMode()) {
                if (!Q.isEmptyOrNull(entity.FrmFollowUp) && this.isValidJSON(entity.FrmFollowUp)) {
                    this.renderFollowUp(JSON.parse(entity.FrmFollowUp).length != 9 ? [] : JSON.parse(entity.FrmFollowUp))
                }
            }
            if (!Q.isEmptyOrNull(entity.Data)) {
                var data = JSON.parse(entity.Data);
                if (data.dataPay) {
                    if (data.dataPay.selected) {
                        this.paymentMethod = Number(data.dataPay.type);
                    }
                } else {
                    this.paymentMethod = 1;
                }
            } else {
                this.paymentMethod = 1;
            }
            if (!Q.isEmptyOrNull(entity.FollowUp)) {
                this.form.FrmFollowUp.set_value(entity.FollowUp);
            } else {
                this.form.FrmFollowUp.set_value(`${1}`);
            }
        }
        isValidJSON(jsonString) {
            try {
                JSON.parse(jsonString);
                return true;
            } catch (error) {
                return false;
            }
        }
        loadEntity(entity: FormresultsRow) {
            super.loadEntity(entity);
            if (this.isEditMode()) {
            }
        }

        renderFollowUp(listFollowUp: followUp[]) {
            if (listFollowUp != null) {
                if (listFollowUp.length != 0) {
                    this.dataFollowUp = listFollowUp;
                    this.form.FrmFollowUp.addFollowUp(this.dataFollowUp);
                } else {
                    this.form.FrmFollowUp.addFollowUp(this.dataFollowUp);
                }
            } else {
                this.form.FrmFollowUp.addFollowUp(this.dataFollowUp);
            }
        }

        getFollowUpData(id): followUpItem {
            var find = this.dataFollowUp.filter(x => x.id == parseInt(id));
            if (find.length == 0) {
                return null;
            } else {
                var data = find[0].data;
                var fData = data.filter(x => x.id == this.paymentMethod);
                if (fData.length == 0) {
                    return null;
                } else {
                    return fData[0];
                }
            }
        }

        getToolbarButtons() {
            var buttons = super.getToolbarButtons();
            return [];
        }

        getSaveEntity() {
            var entity = super.getSaveEntity();
            delete entity.Text;
            return entity;
        }

        getDialogButtons() {
            var buttons: Serenity.DialogButton[] = [];
            buttons.push({
                text: "Cancel",
                cssClass: "lkbtn lkbtn-secondary",
                hint: "Cancel",
                click: (e) => {
                    this.dialogClose();
                }
            });
            buttons.push({
                text: "Submit",
                cssClass: "lkbtn lkbtn-primary",
                hint: "Submit",
                click: (e) => {
                    if (this.validateForm()) {
                        this.save((res) => {
                            let entity = this.get_entity();
                            let fields = JSON.parse(entity.Data).dataField;
                            let dataWa = null, dataMail = null, fldWa = fields.find(obj => obj.id == 2), fldMail = fields.find(obj => obj.id == 3);

                            if (fldWa) {
                                if (entity.FrmIsSendWa == 1 && this.isValidJSON(entity.FrmDataWa) && !Q.isEmptyOrNull(fldWa.value)) {
                                    dataWa = JSON.parse(entity.FrmDataWa);
                                    dataWa.toIdExt = fldWa.value;
                                }
                            }

                            if (fldMail) {
                                if (entity.FrmIsSendMail == 1 && this.isValidJSON(entity.FrmDataMail) && this.emailRegex.test(fldMail.value)) {
                                    dataMail = JSON.parse(entity.FrmDataMail);
                                    dataMail.toIdExt = fldMail.value;
                                }
                            }

                            let redirectToWa = () => {
                                let val = encodeURIComponent(this.form.Text.value);
                                window.open(`https://wa.me/${this.entity.Phone[0] == "0" ? this.countryCode + this.entity.Phone.substring(1) : this.entity.Phone}/?text=${val}`);
                            }

                            let kirimLewatAkun = async (pesan) => {
                                let objFlUp = this.form.FrmFollowUp.items.filter(x => x.id == this.form.FrmFollowUp.get_value());
                                let getNamaStatus = (st: FormStatusEnum) => {
                                    if (st == FormStatusEnum.Cancel) {
                                        return "Cancel";
                                    } else if (st == FormStatusEnum.Complete) {
                                        return "Complete";
                                    } else if (st == FormStatusEnum.Pending) {
                                        return "Pending";
                                    } else if (st == FormStatusEnum.Process) {
                                        return "Process";
                                    } else if (st == FormStatusEnum.Refund) {
                                        return "Refund";
                                    }
                                }
                                let req = {
                                    FrmRs: {
                                        Id: entity.Id,
                                        FrmIsSendWa: entity.FrmIsSendWa,
                                        FrmDataWa: dataWa ? JSON.stringify(dataWa) : null,
                                        FrmIsSendMail: entity.FrmIsSendMail,
                                        FrmDataMail: dataMail ? JSON.stringify(dataMail) : null,
                                        Form: entity.Form,
                                        DateIn: entity.DateIn,
                                        SenderNm: entity.SenderNm,
                                        TagIds: entity.TagIds
                                    } as FormresultsRow,
                                    Msg: this.form.Text.value,
                                    Subject: `${objFlUp[0].text} - ${entity.Form} - ${entity.Id} - ${entity.SenderNm} - ${getNamaStatus(entity.St)}`,
                                    TnId: Number($("#GridDiv").attr("tnId"))
                                };
                                await Q.serviceCall({
                                    url: "/Form/SendFollowUp",
                                    request: req,
                                    blockUI: true,
                                    onSuccess: (resFl) => {
                                        if (resFl.IsError) {
                                            redirectToWa();
                                        } else {
                                            Q.notifySuccess(pesan);
                                        }
                                    }
                                })
                            }

                            if (dataWa == null) {
                                if (dataMail == null) {
                                    redirectToWa();
                                } else {
                                    kirimLewatAkun("Follow up successfully sent via Email");
                                }
                            } else {
                                kirimLewatAkun(dataMail ? "Follow up successfully sent via WhatsApp and Email" : "Follow up successfully sent via WhatsApp")
                            }

                            this.dialogClose();
                        });
                    }
                }
            });
            return buttons;
        }

    }
}